/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.5.0 (NJsonSchema v10.6.6.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class AppointmentsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAgentAppointments(ensUserTid: number): Promise<AgentAppointment[]> {
        let url_ = this.baseUrl + "/Appointments/{ensUserTid}";
        if (ensUserTid === undefined || ensUserTid === null)
            throw new Error("The parameter 'ensUserTid' must be defined.");
        url_ = url_.replace("{ensUserTid}", encodeURIComponent("" + ensUserTid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgentAppointments(_response);
        });
    }

    protected processGetAgentAppointments(response: Response): Promise<AgentAppointment[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgentAppointment.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentAppointment[]>(<any>null);
    }
}

export class BrokerIdClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getBrokerIds(ensUserTid: number): Promise<BrokerIdInfo[]> {
        let url_ = this.baseUrl + "/BrokerId/{ensUserTid}";
        if (ensUserTid === undefined || ensUserTid === null)
            throw new Error("The parameter 'ensUserTid' must be defined.");
        url_ = url_.replace("{ensUserTid}", encodeURIComponent("" + ensUserTid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBrokerIds(_response);
        });
    }

    protected processGetBrokerIds(response: Response): Promise<BrokerIdInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BrokerIdInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BrokerIdInfo[]>(<any>null);
    }

    addBrokerId(ensUserTid: number, req: AddBrokerIdRequest): Promise<BrokerIdInfo> {
        let url_ = this.baseUrl + "/BrokerId/{ensUserTid}";
        if (ensUserTid === undefined || ensUserTid === null)
            throw new Error("The parameter 'ensUserTid' must be defined.");
        url_ = url_.replace("{ensUserTid}", encodeURIComponent("" + ensUserTid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddBrokerId(_response);
        });
    }

    protected processAddBrokerId(response: Response): Promise<BrokerIdInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BrokerIdInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BrokerIdInfo>(<any>null);
    }

    updateBrokerId(ensUserBrokerIdTid: number, req: UpdateBrokerIdRequest): Promise<BrokerIdInfo> {
        let url_ = this.baseUrl + "/BrokerId/{ensUserBrokerIdTid}";
        if (ensUserBrokerIdTid === undefined || ensUserBrokerIdTid === null)
            throw new Error("The parameter 'ensUserBrokerIdTid' must be defined.");
        url_ = url_.replace("{ensUserBrokerIdTid}", encodeURIComponent("" + ensUserBrokerIdTid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateBrokerId(_response);
        });
    }

    protected processUpdateBrokerId(response: Response): Promise<BrokerIdInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BrokerIdInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BrokerIdInfo>(<any>null);
    }

    deleteBrokerId(ensUserBrokerIdTid: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/BrokerId/{ensUserBrokerIdTid}";
        if (ensUserBrokerIdTid === undefined || ensUserBrokerIdTid === null)
            throw new Error("The parameter 'ensUserBrokerIdTid' must be defined.");
        url_ = url_.replace("{ensUserBrokerIdTid}", encodeURIComponent("" + ensUserBrokerIdTid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteBrokerId(_response);
        });
    }

    protected processDeleteBrokerId(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export class CertificationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getUserCertifications(ensUserTid: number): Promise<AgentCertification[]> {
        let url_ = this.baseUrl + "/Certification/user/{ensUserTid}";
        if (ensUserTid === undefined || ensUserTid === null)
            throw new Error("The parameter 'ensUserTid' must be defined.");
        url_ = url_.replace("{ensUserTid}", encodeURIComponent("" + ensUserTid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserCertifications(_response);
        });
    }

    protected processGetUserCertifications(response: Response): Promise<AgentCertification[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgentCertification.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentCertification[]>(<any>null);
    }

    updateAgentCertificationCompletion(ensUserCertificationTid: number, req: UpdateAgentCertificateCompletion): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Certification/cert/{ensUserCertificationTid}";
        if (ensUserCertificationTid === undefined || ensUserCertificationTid === null)
            throw new Error("The parameter 'ensUserCertificationTid' must be defined.");
        url_ = url_.replace("{ensUserCertificationTid}", encodeURIComponent("" + ensUserCertificationTid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateAgentCertificationCompletion(_response);
        });
    }

    protected processUpdateAgentCertificationCompletion(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    generateCerts(ensUserTid: number, year: number | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Certification/user/{ensUserTid}/generate?";
        if (ensUserTid === undefined || ensUserTid === null)
            throw new Error("The parameter 'ensUserTid' must be defined.");
        url_ = url_.replace("{ensUserTid}", encodeURIComponent("" + ensUserTid));
        if (year !== undefined && year !== null)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerateCerts(_response);
        });
    }

    protected processGenerateCerts(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export class HealthClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getHealth(): Promise<HealthStatus> {
        let url_ = this.baseUrl + "/Health";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHealth(_response);
        });
    }

    protected processGetHealth(response: Response): Promise<HealthStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthStatus.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthStatus>(<any>null);
    }
}

export class NiprClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getLastNiprStatus(): Promise<NiprLastUpdate> {
        let url_ = this.baseUrl + "/Nipr/latest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLastNiprStatus(_response);
        });
    }

    protected processGetLastNiprStatus(response: Response): Promise<NiprLastUpdate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NiprLastUpdate.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NiprLastUpdate>(<any>null);
    }
}

export class AgentStateLicensesRequestClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    submitAgentStateLicenseRequest(agentStateLicensesRequest: AgentStateLicensesRequestSubmit): Promise<number> {
        let url_ = this.baseUrl + "/AgentStateLicensesRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(agentStateLicensesRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSubmitAgentStateLicenseRequest(_response);
        });
    }

    protected processSubmitAgentStateLicenseRequest(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(<any>null);
    }

    getAgentStateLicensingRequest(ensLicensingRequestTid: number): Promise<AgentStateLicensesRequest> {
        let url_ = this.baseUrl + "/AgentStateLicensesRequest/{ensLicensingRequestTid}";
        if (ensLicensingRequestTid === undefined || ensLicensingRequestTid === null)
            throw new Error("The parameter 'ensLicensingRequestTid' must be defined.");
        url_ = url_.replace("{ensLicensingRequestTid}", encodeURIComponent("" + ensLicensingRequestTid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgentStateLicensingRequest(_response);
        });
    }

    protected processGetAgentStateLicensingRequest(response: Response): Promise<AgentStateLicensesRequest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgentStateLicensesRequest.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentStateLicensesRequest>(<any>null);
    }

    updateAgentStateLicensingRequest(ensLicensingRequestTid: number, updateReq: AgentStateLicensesRequestUpdate): Promise<AgentStateLicensesRequest> {
        let url_ = this.baseUrl + "/AgentStateLicensesRequest/{ensLicensingRequestTid}";
        if (ensLicensingRequestTid === undefined || ensLicensingRequestTid === null)
            throw new Error("The parameter 'ensLicensingRequestTid' must be defined.");
        url_ = url_.replace("{ensLicensingRequestTid}", encodeURIComponent("" + ensLicensingRequestTid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateReq);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateAgentStateLicensingRequest(_response);
        });
    }

    protected processUpdateAgentStateLicensingRequest(response: Response): Promise<AgentStateLicensesRequest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgentStateLicensesRequest.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentStateLicensesRequest>(<any>null);
    }
}

export class RequestsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getRequestsForReview(): Promise<LicenseRequest[]> {
        let url_ = this.baseUrl + "/Requests/review";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRequestsForReview(_response);
        });
    }

    protected processGetRequestsForReview(response: Response): Promise<LicenseRequest[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LicenseRequest.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseRequest[]>(<any>null);
    }

    getLatestRequests(limit: number | null | undefined): Promise<LicenseRequest[]> {
        let url_ = this.baseUrl + "/Requests/latest?";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLatestRequests(_response);
        });
    }

    protected processGetLatestRequests(response: Response): Promise<LicenseRequest[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LicenseRequest.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseRequest[]>(<any>null);
    }
}

export class ReportsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getLicensedAgents(): Promise<LicensedAgent[]> {
        let url_ = this.baseUrl + "/Reports/agents";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLicensedAgents(_response);
        });
    }

    protected processGetLicensedAgents(response: Response): Promise<LicensedAgent[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LicensedAgent.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicensedAgent[]>(<any>null);
    }
}

export class ReadyToSellClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAgentRtsStatuses(ensUserTid: number, productCarrierTid: EnsProductCarrierTid | undefined, productCategoryTid: EnsProductCategory | undefined, effectiveYear: number | undefined): Promise<RtsStatus[]> {
        let url_ = this.baseUrl + "/ReadyToSell/{ensUserTid}?";
        if (ensUserTid === undefined || ensUserTid === null)
            throw new Error("The parameter 'ensUserTid' must be defined.");
        url_ = url_.replace("{ensUserTid}", encodeURIComponent("" + ensUserTid));
        if (productCarrierTid === null)
            throw new Error("The parameter 'productCarrierTid' cannot be null.");
        else if (productCarrierTid !== undefined)
            url_ += "productCarrierTid=" + encodeURIComponent("" + productCarrierTid) + "&";
        if (productCategoryTid === null)
            throw new Error("The parameter 'productCategoryTid' cannot be null.");
        else if (productCategoryTid !== undefined)
            url_ += "productCategoryTid=" + encodeURIComponent("" + productCategoryTid) + "&";
        if (effectiveYear === null)
            throw new Error("The parameter 'effectiveYear' cannot be null.");
        else if (effectiveYear !== undefined)
            url_ += "effectiveYear=" + encodeURIComponent("" + effectiveYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgentRtsStatuses(_response);
        });
    }

    protected processGetAgentRtsStatuses(response: Response): Promise<RtsStatus[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RtsStatus.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RtsStatus[]>(<any>null);
    }

    getAgentsRtsStatuses(req: ReadyToSellStatusesRequest): Promise<WorkStartResponseOfListOfAgentRtsStatuses> {
        let url_ = this.baseUrl + "/ReadyToSell";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgentsRtsStatuses(_response);
        });
    }

    protected processGetAgentsRtsStatuses(response: Response): Promise<WorkStartResponseOfListOfAgentRtsStatuses> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkStartResponseOfListOfAgentRtsStatuses.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkStartResponseOfListOfAgentRtsStatuses>(<any>null);
    }
}

export class ReadyToSellJobClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getUploadUrl(): Promise<PreSignedUrlResponse> {
        let url_ = this.baseUrl + "/ReadyToSellJob/upload";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUploadUrl(_response);
        });
    }

    protected processGetUploadUrl(response: Response): Promise<PreSignedUrlResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreSignedUrlResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PreSignedUrlResponse>(<any>null);
    }

    processReport(guid: string | null, reportType: ReadyToSellReportType | undefined): Promise<ReadyToSellJob> {
        let url_ = this.baseUrl + "/ReadyToSellJob/{guid}?";
        if (guid === undefined || guid === null)
            throw new Error("The parameter 'guid' must be defined.");
        url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
        if (reportType === null)
            throw new Error("The parameter 'reportType' cannot be null.");
        else if (reportType !== undefined)
            url_ += "reportType=" + encodeURIComponent("" + reportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProcessReport(_response);
        });
    }

    protected processProcessReport(response: Response): Promise<ReadyToSellJob> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReadyToSellJob.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReadyToSellJob>(<any>null);
    }

    getLatest(): Promise<ReadyToSellJobStatus[]> {
        let url_ = this.baseUrl + "/ReadyToSellJob/latest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLatest(_response);
        });
    }

    protected processGetLatest(response: Response): Promise<ReadyToSellJobStatus[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReadyToSellJobStatus.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReadyToSellJobStatus[]>(<any>null);
    }
}

export class ReportsOnDemandClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    agentsRequiringCe(): Promise<ReportsOnDemandJob> {
        let url_ = this.baseUrl + "/ReportsOnDemand/requestReport/AgentsRequiringCe";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAgentsRequiringCe(_response);
        });
    }

    protected processAgentsRequiringCe(response: Response): Promise<ReportsOnDemandJob> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportsOnDemandJob.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportsOnDemandJob>(<any>null);
    }

    expiringLicensesReport(): Promise<ReportsOnDemandJob> {
        let url_ = this.baseUrl + "/ReportsOnDemand/requestReport/ExpiringLicensesReportTask";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExpiringLicensesReport(_response);
        });
    }

    protected processExpiringLicensesReport(response: Response): Promise<ReportsOnDemandJob> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportsOnDemandJob.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportsOnDemandJob>(<any>null);
    }

    getLatest(): Promise<ReportsOnDemandJobStatus[]> {
        let url_ = this.baseUrl + "/ReportsOnDemand/latest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLatest(_response);
        });
    }

    protected processGetLatest(response: Response): Promise<ReportsOnDemandJobStatus[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReportsOnDemandJobStatus.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportsOnDemandJobStatus[]>(<any>null);
    }
}

export class LicensesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getLicenses(): Promise<License[]> {
        let url_ = this.baseUrl + "/";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLicenses(_response);
        });
    }

    protected processGetLicenses(response: Response): Promise<License[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(License.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<License[]>(<any>null);
    }

    getAgentLicenses(ensUserTid: number): Promise<License[]> {
        let url_ = this.baseUrl + "/EnsUser/{ensUserTid}";
        if (ensUserTid === undefined || ensUserTid === null)
            throw new Error("The parameter 'ensUserTid' must be defined.");
        url_ = url_.replace("{ensUserTid}", encodeURIComponent("" + ensUserTid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgentLicenses(_response);
        });
    }

    protected processGetAgentLicenses(response: Response): Promise<License[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(License.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<License[]>(<any>null);
    }

    getLicenseLoas(ensUserLicenseTid: number): Promise<LicenseLoa[]> {
        let url_ = this.baseUrl + "/loas/{ensUserLicenseTid}";
        if (ensUserLicenseTid === undefined || ensUserLicenseTid === null)
            throw new Error("The parameter 'ensUserLicenseTid' must be defined.");
        url_ = url_.replace("{ensUserLicenseTid}", encodeURIComponent("" + ensUserLicenseTid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLicenseLoas(_response);
        });
    }

    protected processGetLicenseLoas(response: Response): Promise<LicenseLoa[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LicenseLoa.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseLoa[]>(<any>null);
    }
}

export class AgentAppointment implements IAgentAppointment {
    state!: string;
    appointmentDate!: Date | undefined;
    expirationDate!: Date | undefined;
    brokerId!: BrokerIdInfo;
    appointmentStatus!: AgentAppointmentStatus;

    constructor(data?: IAgentAppointment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.brokerId = new BrokerIdInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.appointmentDate = _data["appointmentDate"] ? new Date(_data["appointmentDate"].toString()) : <any>undefined;
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.brokerId = _data["brokerId"] ? BrokerIdInfo.fromJS(_data["brokerId"]) : new BrokerIdInfo();
            this.appointmentStatus = _data["appointmentStatus"];
        }
    }

    static fromJS(data: any): AgentAppointment {
        data = typeof data === 'object' ? data : {};
        let result = new AgentAppointment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["appointmentDate"] = this.appointmentDate ? this.appointmentDate.toISOString() : <any>undefined;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["brokerId"] = this.brokerId ? this.brokerId.toJSON() : <any>undefined;
        data["appointmentStatus"] = this.appointmentStatus;
        return data;
    }
}

export interface IAgentAppointment {
    state: string;
    appointmentDate: Date | undefined;
    expirationDate: Date | undefined;
    brokerId: BrokerIdInfo;
    appointmentStatus: AgentAppointmentStatus;
}

export class BrokerIdInfo implements IBrokerIdInfo {
    brokerIdTid!: number;
    brokerId!: string;
    productCategory!: ProductCategory;
    carrier!: ProductCarrier;

    constructor(data?: IBrokerIdInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.productCategory = new ProductCategory();
            this.carrier = new ProductCarrier();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.brokerIdTid = _data["brokerIdTid"];
            this.brokerId = _data["brokerId"];
            this.productCategory = _data["productCategory"] ? ProductCategory.fromJS(_data["productCategory"]) : new ProductCategory();
            this.carrier = _data["carrier"] ? ProductCarrier.fromJS(_data["carrier"]) : new ProductCarrier();
        }
    }

    static fromJS(data: any): BrokerIdInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BrokerIdInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brokerIdTid"] = this.brokerIdTid;
        data["brokerId"] = this.brokerId;
        data["productCategory"] = this.productCategory ? this.productCategory.toJSON() : <any>undefined;
        data["carrier"] = this.carrier ? this.carrier.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBrokerIdInfo {
    brokerIdTid: number;
    brokerId: string;
    productCategory: ProductCategory;
    carrier: ProductCarrier;
}

export class ProductCategory implements IProductCategory {
    ensProductCategoryTid!: EnsProductCategory;
    productCategoryName!: string;

    constructor(data?: IProductCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ensProductCategoryTid = _data["ensProductCategoryTid"];
            this.productCategoryName = _data["productCategoryName"];
        }
    }

    static fromJS(data: any): ProductCategory {
        data = typeof data === 'object' ? data : {};
        let result = new ProductCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ensProductCategoryTid"] = this.ensProductCategoryTid;
        data["productCategoryName"] = this.productCategoryName;
        return data;
    }
}

export interface IProductCategory {
    ensProductCategoryTid: EnsProductCategory;
    productCategoryName: string;
}

export enum EnsProductCategory {
    None = 0,
    LifeInsurance = 2,
    MedicalPlan = 3,
    MedicareAdvantage = 4,
    MedicarePdp = 5,
    MedSupp = 6,
    Other = 7,
    VisionDentalHearing = 8,
    MedicareMedicaid = 9,
    MedicareCore = 10,
    DownstreamMa = 11,
    DownstreamPdp = 12,
    OptionalSupplementalBenefit = 13,
    Error = -1,
}

export class ProductCarrier implements IProductCarrier {
    ensProductCarrierTid!: EnsProductCarrierTid;
    productCarrierName!: string;

    constructor(data?: IProductCarrier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ensProductCarrierTid = _data["ensProductCarrierTid"];
            this.productCarrierName = _data["productCarrierName"];
        }
    }

    static fromJS(data: any): ProductCarrier {
        data = typeof data === 'object' ? data : {};
        let result = new ProductCarrier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ensProductCarrierTid"] = this.ensProductCarrierTid;
        data["productCarrierName"] = this.productCarrierName;
        return data;
    }
}

export interface IProductCarrier {
    ensProductCarrierTid: EnsProductCarrierTid;
    productCarrierName: string;
}

export enum EnsProductCarrierTid {
    None = 0,
    GenericNotSpecified = 1,
    Aaa = 2,
    Aetna = 3,
    Ameritas = 4,
    CatholicLife = 5,
    Cigna = 6,
    Humana = 7,
    LibertyBankers = 8,
    MutualOfOmaha = 9,
    NationalHealthInsuranceCompanyNhic = 10,
    Renaissance = 11,
    Sentinel = 12,
    SilverScript = 13,
    Thrivent = 14,
    Ihc = 15,
    Sagicor = 16,
    Securian = 17,
    Hp1 = 18,
    Surebridge = 19,
    AnicoOfNy = 20,
    Anico = 21,
    HarvardPilgrim = 24,
    Gerber = 25,
    Anthem = 26,
    Cdphp = 28,
    Aig = 29,
    UnitedHealthcare = 30,
    WellCare = 31,
    SunFire = 32,
    PanAmerican = 33,
    AgentE = 34,
    PeoplesHealth = 35,
    ChoicePolicy = 36,
    Aarp = 37,
    Accendo = 39,
    ContinentalLife = 40,
    BlueCrossBlueShield = 41,
    Aflac = 42,
    Unknown = -1,
}

export enum AgentAppointmentStatus {
    NotAppointed = 0,
    JustInTimeAppointed = 1,
    Appointed = 2,
}

export class AddBrokerIdRequest implements IAddBrokerIdRequest {
    brokerId!: string;
    ensProductCarrierTid!: EnsProductCarrierTid;
    ensProductCategoryTid!: EnsProductCategory;

    constructor(data?: IAddBrokerIdRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.brokerId = _data["brokerId"];
            this.ensProductCarrierTid = _data["ensProductCarrierTid"];
            this.ensProductCategoryTid = _data["ensProductCategoryTid"];
        }
    }

    static fromJS(data: any): AddBrokerIdRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddBrokerIdRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brokerId"] = this.brokerId;
        data["ensProductCarrierTid"] = this.ensProductCarrierTid;
        data["ensProductCategoryTid"] = this.ensProductCategoryTid;
        return data;
    }
}

export interface IAddBrokerIdRequest {
    brokerId: string;
    ensProductCarrierTid: EnsProductCarrierTid;
    ensProductCategoryTid: EnsProductCategory;
}

export class UpdateBrokerIdRequest implements IUpdateBrokerIdRequest {
    brokerId?: string | undefined;
    ensProductCarrierTid?: EnsProductCarrierTid | undefined;
    ensProductCategoryTid?: EnsProductCategory | undefined;

    constructor(data?: IUpdateBrokerIdRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.brokerId = _data["brokerId"];
            this.ensProductCarrierTid = _data["ensProductCarrierTid"];
            this.ensProductCategoryTid = _data["ensProductCategoryTid"];
        }
    }

    static fromJS(data: any): UpdateBrokerIdRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBrokerIdRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brokerId"] = this.brokerId;
        data["ensProductCarrierTid"] = this.ensProductCarrierTid;
        data["ensProductCategoryTid"] = this.ensProductCategoryTid;
        return data;
    }
}

export interface IUpdateBrokerIdRequest {
    brokerId?: string | undefined;
    ensProductCarrierTid?: EnsProductCarrierTid | undefined;
    ensProductCategoryTid?: EnsProductCategory | undefined;
}

export class AgentCertification implements IAgentCertification {
    ensUserCertificationTid!: number;
    ensUserCertificationTypeTid!: number;
    userCertificationName!: string;
    expirationDateUnix!: number | undefined;
    completeFl!: boolean;

    constructor(data?: IAgentCertification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ensUserCertificationTid = _data["ensUserCertificationTid"];
            this.ensUserCertificationTypeTid = _data["ensUserCertificationTypeTid"];
            this.userCertificationName = _data["userCertificationName"];
            this.expirationDateUnix = _data["expirationDateUnix"];
            this.completeFl = _data["completeFl"];
        }
    }

    static fromJS(data: any): AgentCertification {
        data = typeof data === 'object' ? data : {};
        let result = new AgentCertification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ensUserCertificationTid"] = this.ensUserCertificationTid;
        data["ensUserCertificationTypeTid"] = this.ensUserCertificationTypeTid;
        data["userCertificationName"] = this.userCertificationName;
        data["expirationDateUnix"] = this.expirationDateUnix;
        data["completeFl"] = this.completeFl;
        return data;
    }
}

export interface IAgentCertification {
    ensUserCertificationTid: number;
    ensUserCertificationTypeTid: number;
    userCertificationName: string;
    expirationDateUnix: number | undefined;
    completeFl: boolean;
}

export class UpdateAgentCertificateCompletion implements IUpdateAgentCertificateCompletion {
    complete!: boolean;

    constructor(data?: IUpdateAgentCertificateCompletion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.complete = _data["complete"];
        }
    }

    static fromJS(data: any): UpdateAgentCertificateCompletion {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAgentCertificateCompletion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["complete"] = this.complete;
        return data;
    }
}

export interface IUpdateAgentCertificateCompletion {
    complete: boolean;
}

export class HealthStatus implements IHealthStatus {
    service?: string | undefined;
    buildEnvironment?: string | undefined;
    database?: string | undefined;
    requestDateUtc?: Date;

    constructor(data?: IHealthStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.service = _data["service"];
            this.buildEnvironment = _data["buildEnvironment"];
            this.database = _data["database"];
            this.requestDateUtc = _data["requestDateUtc"] ? new Date(_data["requestDateUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HealthStatus {
        data = typeof data === 'object' ? data : {};
        let result = new HealthStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["service"] = this.service;
        data["buildEnvironment"] = this.buildEnvironment;
        data["database"] = this.database;
        data["requestDateUtc"] = this.requestDateUtc ? this.requestDateUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface IHealthStatus {
    service?: string | undefined;
    buildEnvironment?: string | undefined;
    database?: string | undefined;
    requestDateUtc?: Date;
}

export class NiprLastUpdate implements INiprLastUpdate {
    appointmentStatus!: NiprTaskStatus;
    licensingStatus!: NiprTaskStatus;

    constructor(data?: INiprLastUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.appointmentStatus = new NiprTaskStatus();
            this.licensingStatus = new NiprTaskStatus();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentStatus = _data["appointmentStatus"] ? NiprTaskStatus.fromJS(_data["appointmentStatus"]) : new NiprTaskStatus();
            this.licensingStatus = _data["licensingStatus"] ? NiprTaskStatus.fromJS(_data["licensingStatus"]) : new NiprTaskStatus();
        }
    }

    static fromJS(data: any): NiprLastUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new NiprLastUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointmentStatus"] = this.appointmentStatus ? this.appointmentStatus.toJSON() : <any>undefined;
        data["licensingStatus"] = this.licensingStatus ? this.licensingStatus.toJSON() : <any>undefined;
        return data;
    }
}

export interface INiprLastUpdate {
    appointmentStatus: NiprTaskStatus;
    licensingStatus: NiprTaskStatus;
}

export class NiprTaskStatus implements INiprTaskStatus {
    lastRunTimestamp!: Date | undefined;
    lastRunStatus!: CronTaskStateType;
    lastSuccessfulTimestamp!: Date | undefined;

    constructor(data?: INiprTaskStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastRunTimestamp = _data["lastRunTimestamp"] ? new Date(_data["lastRunTimestamp"].toString()) : <any>undefined;
            this.lastRunStatus = _data["lastRunStatus"];
            this.lastSuccessfulTimestamp = _data["lastSuccessfulTimestamp"] ? new Date(_data["lastSuccessfulTimestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NiprTaskStatus {
        data = typeof data === 'object' ? data : {};
        let result = new NiprTaskStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastRunTimestamp"] = this.lastRunTimestamp ? this.lastRunTimestamp.toISOString() : <any>undefined;
        data["lastRunStatus"] = this.lastRunStatus;
        data["lastSuccessfulTimestamp"] = this.lastSuccessfulTimestamp ? this.lastSuccessfulTimestamp.toISOString() : <any>undefined;
        return data;
    }
}

export interface INiprTaskStatus {
    lastRunTimestamp: Date | undefined;
    lastRunStatus: CronTaskStateType;
    lastSuccessfulTimestamp: Date | undefined;
}

export enum CronTaskStateType {
    Provisioning = 0,
    Running = 1,
    Success = 2,
    Failure = 3,
}

export class AgentStateLicensesRequestSubmit implements IAgentStateLicensesRequestSubmit {
    requestorEnsUserTid!: number;
    targetEnsUserTid!: number;
    states!: string[];

    constructor(data?: IAgentStateLicensesRequestSubmit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.states = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestorEnsUserTid = _data["requestorEnsUserTid"];
            this.targetEnsUserTid = _data["targetEnsUserTid"];
            if (Array.isArray(_data["states"])) {
                this.states = [] as any;
                for (let item of _data["states"])
                    this.states!.push(item);
            }
        }
    }

    static fromJS(data: any): AgentStateLicensesRequestSubmit {
        data = typeof data === 'object' ? data : {};
        let result = new AgentStateLicensesRequestSubmit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestorEnsUserTid"] = this.requestorEnsUserTid;
        data["targetEnsUserTid"] = this.targetEnsUserTid;
        if (Array.isArray(this.states)) {
            data["states"] = [];
            for (let item of this.states)
                data["states"].push(item);
        }
        return data;
    }
}

export interface IAgentStateLicensesRequestSubmit {
    requestorEnsUserTid: number;
    targetEnsUserTid: number;
    states: string[];
}

export class LicenseRequest implements ILicenseRequest {
    ensLicenseRequestTid!: number;
    ensLicensingRequestType!: EnsLicensingRequestTypeTid;
    ensLicensingRequestStatusType!: EnsLicensingRequestStatusTypeTid;
    requestor!: LicenseRequestEnsUser;
    target!: LicenseRequestEnsUser;
    approvalDateTime?: Date | undefined;

    constructor(data?: ILicenseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.requestor = new LicenseRequestEnsUser();
            this.target = new LicenseRequestEnsUser();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ensLicenseRequestTid = _data["ensLicenseRequestTid"];
            this.ensLicensingRequestType = _data["ensLicensingRequestType"];
            this.ensLicensingRequestStatusType = _data["ensLicensingRequestStatusType"];
            this.requestor = _data["requestor"] ? LicenseRequestEnsUser.fromJS(_data["requestor"]) : new LicenseRequestEnsUser();
            this.target = _data["target"] ? LicenseRequestEnsUser.fromJS(_data["target"]) : new LicenseRequestEnsUser();
            this.approvalDateTime = _data["approvalDateTime"] ? new Date(_data["approvalDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): LicenseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ensLicenseRequestTid"] = this.ensLicenseRequestTid;
        data["ensLicensingRequestType"] = this.ensLicensingRequestType;
        data["ensLicensingRequestStatusType"] = this.ensLicensingRequestStatusType;
        data["requestor"] = this.requestor ? this.requestor.toJSON() : <any>undefined;
        data["target"] = this.target ? this.target.toJSON() : <any>undefined;
        data["approvalDateTime"] = this.approvalDateTime ? this.approvalDateTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface ILicenseRequest {
    ensLicenseRequestTid: number;
    ensLicensingRequestType: EnsLicensingRequestTypeTid;
    ensLicensingRequestStatusType: EnsLicensingRequestStatusTypeTid;
    requestor: LicenseRequestEnsUser;
    target: LicenseRequestEnsUser;
    approvalDateTime?: Date | undefined;
}

export class AgentStateLicensesRequest extends LicenseRequest implements IAgentStateLicensesRequest {
    states!: AgentStateLicensesRequestState[];

    constructor(data?: IAgentStateLicensesRequest) {
        super(data);
        if (!data) {
            this.states = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["states"])) {
                this.states = [] as any;
                for (let item of _data["states"])
                    this.states!.push(AgentStateLicensesRequestState.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AgentStateLicensesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AgentStateLicensesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.states)) {
            data["states"] = [];
            for (let item of this.states)
                data["states"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IAgentStateLicensesRequest extends ILicenseRequest {
    states: AgentStateLicensesRequestState[];
}

export class AgentStateLicensesRequestState implements IAgentStateLicensesRequestState {
    state!: string;
    approved?: boolean | undefined;

    constructor(data?: IAgentStateLicensesRequestState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.approved = _data["approved"];
        }
    }

    static fromJS(data: any): AgentStateLicensesRequestState {
        data = typeof data === 'object' ? data : {};
        let result = new AgentStateLicensesRequestState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["approved"] = this.approved;
        return data;
    }
}

export interface IAgentStateLicensesRequestState {
    state: string;
    approved?: boolean | undefined;
}

export enum EnsLicensingRequestTypeTid {
    AgentStateLicenseRequest = 1,
}

export enum EnsLicensingRequestStatusTypeTid {
    AwaitingApproval = 1,
    Approved = 2,
    PartiallyApproved = 3,
    Denied = 4,
}

export class LicenseRequestEnsUser implements ILicenseRequestEnsUser {
    ensUserTid!: number;
    userEmail!: string;

    constructor(data?: ILicenseRequestEnsUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ensUserTid = _data["ensUserTid"];
            this.userEmail = _data["userEmail"];
        }
    }

    static fromJS(data: any): LicenseRequestEnsUser {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseRequestEnsUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ensUserTid"] = this.ensUserTid;
        data["userEmail"] = this.userEmail;
        return data;
    }
}

export interface ILicenseRequestEnsUser {
    ensUserTid: number;
    userEmail: string;
}

export class AgentStateLicensesRequestUpdate implements IAgentStateLicensesRequestUpdate {
    approvedStates!: string[];
    deniedStates!: string[];

    constructor(data?: IAgentStateLicensesRequestUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.approvedStates = [];
            this.deniedStates = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["approvedStates"])) {
                this.approvedStates = [] as any;
                for (let item of _data["approvedStates"])
                    this.approvedStates!.push(item);
            }
            if (Array.isArray(_data["deniedStates"])) {
                this.deniedStates = [] as any;
                for (let item of _data["deniedStates"])
                    this.deniedStates!.push(item);
            }
        }
    }

    static fromJS(data: any): AgentStateLicensesRequestUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new AgentStateLicensesRequestUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.approvedStates)) {
            data["approvedStates"] = [];
            for (let item of this.approvedStates)
                data["approvedStates"].push(item);
        }
        if (Array.isArray(this.deniedStates)) {
            data["deniedStates"] = [];
            for (let item of this.deniedStates)
                data["deniedStates"].push(item);
        }
        return data;
    }
}

export interface IAgentStateLicensesRequestUpdate {
    approvedStates: string[];
    deniedStates: string[];
}

export class LicensedAgent implements ILicensedAgent {
    ens_user_tid!: number;
    licenses!: License[];
    first_name!: string;
    last_name!: string;
    npn!: string;
    active!: boolean;

    constructor(data?: ILicensedAgent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.licenses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ens_user_tid = _data["ens_user_tid"];
            if (Array.isArray(_data["licenses"])) {
                this.licenses = [] as any;
                for (let item of _data["licenses"])
                    this.licenses!.push(License.fromJS(item));
            }
            this.first_name = _data["first_name"];
            this.last_name = _data["last_name"];
            this.npn = _data["npn"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): LicensedAgent {
        data = typeof data === 'object' ? data : {};
        let result = new LicensedAgent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_user_tid"] = this.ens_user_tid;
        if (Array.isArray(this.licenses)) {
            data["licenses"] = [];
            for (let item of this.licenses)
                data["licenses"].push(item.toJSON());
        }
        data["first_name"] = this.first_name;
        data["last_name"] = this.last_name;
        data["npn"] = this.npn;
        data["active"] = this.active;
        return data;
    }
}

export interface ILicensedAgent {
    ens_user_tid: number;
    licenses: License[];
    first_name: string;
    last_name: string;
    npn: string;
    active: boolean;
}

export class License implements ILicense {
    ens_user_license_tid!: number;
    ens_user_tid!: number;
    license_number!: string;
    state!: string;
    issued_date?: Date | undefined;
    expiration_date?: Date | undefined;
    class?: string | undefined;
    license_loas!: LicenseLoa[];

    constructor(data?: ILicense) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.license_loas = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ens_user_license_tid = _data["ens_user_license_tid"];
            this.ens_user_tid = _data["ens_user_tid"];
            this.license_number = _data["license_number"];
            this.state = _data["state"];
            this.issued_date = _data["issued_date"] ? new Date(_data["issued_date"].toString()) : <any>undefined;
            this.expiration_date = _data["expiration_date"] ? new Date(_data["expiration_date"].toString()) : <any>undefined;
            this.class = _data["class"];
            if (Array.isArray(_data["license_loas"])) {
                this.license_loas = [] as any;
                for (let item of _data["license_loas"])
                    this.license_loas!.push(LicenseLoa.fromJS(item));
            }
        }
    }

    static fromJS(data: any): License {
        data = typeof data === 'object' ? data : {};
        let result = new License();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_user_license_tid"] = this.ens_user_license_tid;
        data["ens_user_tid"] = this.ens_user_tid;
        data["license_number"] = this.license_number;
        data["state"] = this.state;
        data["issued_date"] = this.issued_date ? this.issued_date.toISOString() : <any>undefined;
        data["expiration_date"] = this.expiration_date ? this.expiration_date.toISOString() : <any>undefined;
        data["class"] = this.class;
        if (Array.isArray(this.license_loas)) {
            data["license_loas"] = [];
            for (let item of this.license_loas)
                data["license_loas"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILicense {
    ens_user_license_tid: number;
    ens_user_tid: number;
    license_number: string;
    state: string;
    issued_date?: Date | undefined;
    expiration_date?: Date | undefined;
    class?: string | undefined;
    license_loas: LicenseLoa[];
}

export class LicenseLoa implements ILicenseLoa {
    nipr_report_pdb_producer_license_loa_tid!: number;
    nipr_report_pdb_producer_license_tid!: number;
    loa_name!: string;
    loa_code!: number;
    loa_issue_date?: Date | undefined;
    loa_status?: string | undefined;
    loa_status_reason?: string | undefined;
    ce_renewal_date?: Date | undefined;

    constructor(data?: ILicenseLoa) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nipr_report_pdb_producer_license_loa_tid = _data["nipr_report_pdb_producer_license_loa_tid"];
            this.nipr_report_pdb_producer_license_tid = _data["nipr_report_pdb_producer_license_tid"];
            this.loa_name = _data["loa_name"];
            this.loa_code = _data["loa_code"];
            this.loa_issue_date = _data["loa_issue_date"] ? new Date(_data["loa_issue_date"].toString()) : <any>undefined;
            this.loa_status = _data["loa_status"];
            this.loa_status_reason = _data["loa_status_reason"];
            this.ce_renewal_date = _data["ce_renewal_date"] ? new Date(_data["ce_renewal_date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): LicenseLoa {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseLoa();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nipr_report_pdb_producer_license_loa_tid"] = this.nipr_report_pdb_producer_license_loa_tid;
        data["nipr_report_pdb_producer_license_tid"] = this.nipr_report_pdb_producer_license_tid;
        data["loa_name"] = this.loa_name;
        data["loa_code"] = this.loa_code;
        data["loa_issue_date"] = this.loa_issue_date ? this.loa_issue_date.toISOString() : <any>undefined;
        data["loa_status"] = this.loa_status;
        data["loa_status_reason"] = this.loa_status_reason;
        data["ce_renewal_date"] = this.ce_renewal_date ? this.ce_renewal_date.toISOString() : <any>undefined;
        return data;
    }
}

export interface ILicenseLoa {
    nipr_report_pdb_producer_license_loa_tid: number;
    nipr_report_pdb_producer_license_tid: number;
    loa_name: string;
    loa_code: number;
    loa_issue_date?: Date | undefined;
    loa_status?: string | undefined;
    loa_status_reason?: string | undefined;
    ce_renewal_date?: Date | undefined;
}

export class RtsStatus implements IRtsStatus {
    state!: string;
    readyToSell!: boolean;
    type!: EnsUserRtsTypeTid;

    constructor(data?: IRtsStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.readyToSell = _data["readyToSell"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): RtsStatus {
        data = typeof data === 'object' ? data : {};
        let result = new RtsStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["readyToSell"] = this.readyToSell;
        data["type"] = this.type;
        return data;
    }
}

export interface IRtsStatus {
    state: string;
    readyToSell: boolean;
    type: EnsUserRtsTypeTid;
}

export enum EnsUserRtsTypeTid {
    Unknown = 0,
    JustInTime = 1,
    Preappointment = 2,
    RtsReport = 3,
}

export class WorkStartResponseOfListOfAgentRtsStatuses implements IWorkStartResponseOfListOfAgentRtsStatuses {
    guid!: string;
    __resultType?: AgentRtsStatuses[] | undefined;

    constructor(data?: IWorkStartResponseOfListOfAgentRtsStatuses) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            if (Array.isArray(_data["__resultType"])) {
                this.__resultType = [] as any;
                for (let item of _data["__resultType"])
                    this.__resultType!.push(AgentRtsStatuses.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkStartResponseOfListOfAgentRtsStatuses {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStartResponseOfListOfAgentRtsStatuses();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        if (Array.isArray(this.__resultType)) {
            data["__resultType"] = [];
            for (let item of this.__resultType)
                data["__resultType"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWorkStartResponseOfListOfAgentRtsStatuses {
    guid: string;
    __resultType?: AgentRtsStatuses[] | undefined;
}

export class AgentRtsStatuses implements IAgentRtsStatuses {
    ensUserTid!: number;
    rtsStatuses!: RtsStatus[];

    constructor(data?: IAgentRtsStatuses) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.rtsStatuses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ensUserTid = _data["ensUserTid"];
            if (Array.isArray(_data["rtsStatuses"])) {
                this.rtsStatuses = [] as any;
                for (let item of _data["rtsStatuses"])
                    this.rtsStatuses!.push(RtsStatus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AgentRtsStatuses {
        data = typeof data === 'object' ? data : {};
        let result = new AgentRtsStatuses();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ensUserTid"] = this.ensUserTid;
        if (Array.isArray(this.rtsStatuses)) {
            data["rtsStatuses"] = [];
            for (let item of this.rtsStatuses)
                data["rtsStatuses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAgentRtsStatuses {
    ensUserTid: number;
    rtsStatuses: RtsStatus[];
}

export class ReadyToSellStatusesRequest implements IReadyToSellStatusesRequest {
    ensUserTids!: number[];
    productCarrierTid!: EnsProductCarrierTid;
    productCategoryTid!: EnsProductCategory;
    effectiveYear!: number;

    constructor(data?: IReadyToSellStatusesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ensUserTids = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ensUserTids"])) {
                this.ensUserTids = [] as any;
                for (let item of _data["ensUserTids"])
                    this.ensUserTids!.push(item);
            }
            this.productCarrierTid = _data["productCarrierTid"];
            this.productCategoryTid = _data["productCategoryTid"];
            this.effectiveYear = _data["effectiveYear"];
        }
    }

    static fromJS(data: any): ReadyToSellStatusesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReadyToSellStatusesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ensUserTids)) {
            data["ensUserTids"] = [];
            for (let item of this.ensUserTids)
                data["ensUserTids"].push(item);
        }
        data["productCarrierTid"] = this.productCarrierTid;
        data["productCategoryTid"] = this.productCategoryTid;
        data["effectiveYear"] = this.effectiveYear;
        return data;
    }
}

export interface IReadyToSellStatusesRequest {
    ensUserTids: number[];
    productCarrierTid: EnsProductCarrierTid;
    productCategoryTid: EnsProductCategory;
    effectiveYear: number;
}

export class PreSignedUrlResponse implements IPreSignedUrlResponse {
    presignedUrl!: string;
    objectPrefix!: string | undefined;
    objectGuid!: string;

    constructor(data?: IPreSignedUrlResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.presignedUrl = _data["presignedUrl"];
            this.objectPrefix = _data["objectPrefix"];
            this.objectGuid = _data["objectGuid"];
        }
    }

    static fromJS(data: any): PreSignedUrlResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PreSignedUrlResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["presignedUrl"] = this.presignedUrl;
        data["objectPrefix"] = this.objectPrefix;
        data["objectGuid"] = this.objectGuid;
        return data;
    }
}

export interface IPreSignedUrlResponse {
    presignedUrl: string;
    objectPrefix: string | undefined;
    objectGuid: string;
}

export class ReadyToSellJob implements IReadyToSellJob {
    guid!: string;

    constructor(data?: IReadyToSellJob) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
        }
    }

    static fromJS(data: any): ReadyToSellJob {
        data = typeof data === 'object' ? data : {};
        let result = new ReadyToSellJob();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        return data;
    }
}

export interface IReadyToSellJob {
    guid: string;
}

export enum ReadyToSellReportType {
    Humana = 0,
    UHC = 1,
    AetnaMA2022 = 2,
    AetnaMA2023 = 3,
    Anthem = 4,
    SunFireSmallCarriers = 5,
    HarvardPilgrim = 6,
    PeoplesHealth = 7,
}

export class ReadyToSellJobStatus implements IReadyToSellJobStatus {
    guid!: string;
    taskName!: string;
    lastEventDatetime!: Date;
    state!: CronTaskStateType2;

    constructor(data?: IReadyToSellJobStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.taskName = _data["taskName"];
            this.lastEventDatetime = _data["lastEventDatetime"] ? new Date(_data["lastEventDatetime"].toString()) : <any>undefined;
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): ReadyToSellJobStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ReadyToSellJobStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["taskName"] = this.taskName;
        data["lastEventDatetime"] = this.lastEventDatetime ? this.lastEventDatetime.toISOString() : <any>undefined;
        data["state"] = this.state;
        return data;
    }
}

export interface IReadyToSellJobStatus {
    guid: string;
    taskName: string;
    lastEventDatetime: Date;
    state: CronTaskStateType2;
}

export enum CronTaskStateType2 {
    Provisioning = 0,
    Running = 1,
    Success = 2,
    Failure = 3,
}

export class ReportsOnDemandJob implements IReportsOnDemandJob {
    guid!: string;

    constructor(data?: IReportsOnDemandJob) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
        }
    }

    static fromJS(data: any): ReportsOnDemandJob {
        data = typeof data === 'object' ? data : {};
        let result = new ReportsOnDemandJob();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        return data;
    }
}

export interface IReportsOnDemandJob {
    guid: string;
}

export class ReportsOnDemandJobStatus implements IReportsOnDemandJobStatus {
    guid!: string;
    taskName!: string;
    lastEventDatetime!: Date;
    state!: CronTaskStateType2;

    constructor(data?: IReportsOnDemandJobStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.taskName = _data["taskName"];
            this.lastEventDatetime = _data["lastEventDatetime"] ? new Date(_data["lastEventDatetime"].toString()) : <any>undefined;
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): ReportsOnDemandJobStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ReportsOnDemandJobStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["taskName"] = this.taskName;
        data["lastEventDatetime"] = this.lastEventDatetime ? this.lastEventDatetime.toISOString() : <any>undefined;
        data["state"] = this.state;
        return data;
    }
}

export interface IReportsOnDemandJobStatus {
    guid: string;
    taskName: string;
    lastEventDatetime: Date;
    state: CronTaskStateType2;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}